import _ from 'lodash'
import * as R from 'ramda'

import { SET_ANSWERS, UPDATE_FEEDBACK_TESTIMONIAL, SET_ENTITIES } from '../../actions'

const answerDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_ANSWERS: {
      const answerDetails = _.without(
        action.answers.map((answer) => answer.answer_detail),
        null
      )
      return _.merge(
        {},
        state,
        _.keyBy(answerDetails, (answerDetail) => answerDetail && answerDetail.id)
      )
    }
    case UPDATE_FEEDBACK_TESTIMONIAL: {
      return _.merge({}, state, {
        [action.answerDetailId]: {
          published_as_testimonial: action.publishedAsTestimonial,
        },
      })
    }
    case SET_ENTITIES:
      return R.merge(state, action.entities.answer_details)

    default:
      return state
  }
}

export default answerDetailsReducer



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/answer_details.js